import React, { useMemo } from "react";
import { Dropdown } from "react-bootstrap";

const normalizeValue = (value) => {
  if (value === null || value === undefined) return "";
  return typeof value === "string" ? value : JSON.stringify(value);
};

export default function ModernSelect({
  value,
  onChange,
  children,
  placeholder = "Select an option",
  disabled = false,
  name,
  id,
  menuClassName = "",
  className = "",
  align,
  ...rest
}) {
  const options = useMemo(() => {
    return React.Children.toArray(children)
      .filter(React.isValidElement)
      .map((child, index) => {
        const optionValue =
          child.props.value !== undefined ? child.props.value : child.props.children;
        return {
          index,
          value: optionValue,
          label: child.props.children,
          disabled: Boolean(child.props.disabled),
        };
      });
  }, [children]);

  const valueKey = normalizeValue(value);

  const activeOption =
    options.find((option) => normalizeValue(option.value) === valueKey) || null;

  const displayLabel = activeOption ? activeOption.label : placeholder;

  const handleSelect = (eventKey) => {
    const option = options.find((item) => String(item.index) === String(eventKey));
    if (!option || !onChange) return;
    const syntheticEvent = {
      target: {
        value: option.value,
        name,
      },
    };
    onChange(syntheticEvent);
  };

  return (
    <Dropdown
      align={align}
      onSelect={handleSelect}
      className={`dropdown-modern-wrapper ${className}`.trim()}
    >
      <Dropdown.Toggle
        id={id}
        className="dropdown-modern-toggle"
        disabled={disabled}
        {...rest}
      >
        <span className="flex-grow-1 text-truncate">{displayLabel}</span>
      </Dropdown.Toggle>
      <Dropdown.Menu className={`dropdown-modern-menu ${menuClassName}`.trim()}>
        {options.map((option) => (
          <Dropdown.Item
            key={option.index}
            eventKey={option.index}
            active={normalizeValue(option.value) === valueKey}
            disabled={option.disabled}
          >
            {option.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

